import { useZones } from 'features/Responder/features/Zones';
import { centroid, normalizePoint } from 'features/Responder/features/Zones';
import React from 'react';
import { Form } from 'react-bootstrap';

export default function ZonePrefill({
  onChangeField = () => {},
  onShapeModeChange = () => {},
  disabled = false,
  selectedZoneId = '',
}) {
  let zonesWithMeta = [];
  try {
    const zonesCtx = useZones();
    zonesWithMeta = zonesCtx?.zonesWithMeta || [];
  } catch (err) {
    zonesWithMeta = [];
  }

  return (
    <>
      <div className="fw-semibold small text-uppercase text-white-50 mb-2">Pre-fill from Zone</div>
      <Form.Group>
        <Form.Select
          size="sm"
          className="responder-input"
          disabled={disabled}
          value={selectedZoneId ?? ''}
          onChange={(e) => {
            if (disabled) return;
            const val = e.target.value;
            if (!val) return;
            const sel = zonesWithMeta.find((z) => `${z.id}` === `${val}`);
            if (!sel) return;
            const raw =
              sel.polygon ?? sel.geometry?.points ?? sel.geometry?.coord ?? sel._points ?? [];
            const points = Array.isArray(raw)
              ? raw.map((pt) => normalizePoint(pt)).filter(Boolean)
              : [];
            const newGeometry = {
              type: 'zone',
              points,
              coord: points,
              isZone: true,
              zoneId: sel.id,
            };
            onChangeField('geometry', newGeometry);
            onChangeField('zoneId', sel.id);

            const zoneLabel = sel.name || `Zone ${sel.id}`;
            if (zoneLabel) {
              onChangeField('label', zoneLabel);
              onChangeField('address', zoneLabel);
            }
            const boundsCenter =
              sel?.bounds &&
              Number.isFinite(sel.bounds.north) &&
              Number.isFinite(sel.bounds.south) &&
              Number.isFinite(sel.bounds.east) &&
              Number.isFinite(sel.bounds.west)
                ? {
                    lat: (sel.bounds.north + sel.bounds.south) / 2,
                    lng: (sel.bounds.east + sel.bounds.west) / 2,
                  }
                : null;
            const center = centroid(points) || boundsCenter || points[0] || null;
            if (center) {
              onChangeField('lat', center.lat);
              onChangeField('lng', center.lng);
            }
            onChangeField('placeId', '');
          }}
        >
          <option value="">— Select zone —</option>
          {zonesWithMeta.map((z) => (
            <option key={z.id} value={z.id}>
              {z.name || `Zone ${z.id}`}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </>
  );
}


